import PriceEstimateContext from 'context/PriceEstimateContext';
import React, { ReactNode, useContext } from 'react';
import Animated, {
  useAnimatedReaction,
  useAnimatedStyle,
} from 'react-native-reanimated';

const PreloadingWrapper = ({
  firstItem,
  secondItem,
  opacitySecondItem = false,
}: {
  firstItem: ReactNode;
  secondItem?: ReactNode;
  opacitySecondItem?: boolean;
}) => {
  const { startButtonOpacity, loadingPrice } = useContext(PriceEstimateContext);

  useAnimatedReaction(
    () => undefined,
    () => {
      if (startButtonOpacity?.value) {
        startButtonOpacity.value = 1;
      }
    },
    []
  );

  const firstItemStyle = useAnimatedStyle(() => {
    const value = startButtonOpacity?.value ?? 1;
    return {
      opacity: Math.max(0.4, value),
      display: loadingPrice ? 'none' : 'flex',
    };
  }, [startButtonOpacity, loadingPrice]);

  const secondItemStyle = useAnimatedStyle(() => {
    const value = startButtonOpacity?.value ?? 1;
    return {
      opacity: opacitySecondItem ? Math.max(0.4, value) : 1,
      display: loadingPrice ? 'flex' : 'none',
    };
  }, [startButtonOpacity, loadingPrice]);
  return (
    <>
      <Animated.View style={[firstItemStyle]}>{firstItem}</Animated.View>
      <Animated.View style={[secondItemStyle]}>{secondItem}</Animated.View>
    </>
  );
};

export default PreloadingWrapper;
